<template>
  <div class="notification-wrapper" :class="[{ show: showModal }]" @click.self="closeModal">
  <div class="notification">
    <div class="close-notify" @click="closeModal">
      <i class="fa fa-times"></i>
    </div>
    <div class="notification-content">
      <p style="text-transform: uppercase;">Enter your postal/ZIP code</p>
      <div v-if="postalError.length > 0" class="info-message error-message">{{ postalError }}</div>
      <div v-else class="info-message">Please note this will restart your order!</div>
      <input type="text" name="postal_code" placeholder="LOR 1W0" v-model="postalCode">
      <button class="enter-postal" @click="checkPostal">Enter</button>

    </div>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      postalCode: null,
    };
  },

  computed: {
    showModal() {
      return this.$store.state.postalModal.showModal;
    },

    postalError() {
      return this.$store.state.postalModal.postalError;
    },
  },

  methods: {
    checkPostal() {
      if (this.postalCode && this.postalCode.length > 0) {
        this.$store.dispatch('setNewPostal', this.postalCode);
      } else {
        this.$store.commit('setProperties', { postalModal: { showModal: true, postalError: 'Please insert a postal/ZIP code' } });
      }
    },

    closeModal() {
      this.postalCode = null;
      this.$store.commit('setProperties', { postalModal: { showModal: false, postalError: '' } });
    },
  },
};
</script>
<style>
  .info-message {
    background-color: #FFF9C4;
    border-left: 3px solid #ffe500;
    margin: 1em;
    padding: 1em;
  }

  .error-message {
    background-color: #FFE6E8;
    color: #cc0015;
    border-left: none;
  }
</style>
